<template>
  <NuxtLayout>
    <NuxtPage/>
    <UNotifications/>
    <DebugToolbar />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import {useUserStore} from "~/stores/useUserStore";

// SEO
useSeoWrapper().setSeoMeta()

// Didomi consent manager
useDidomi().init()

const colorMode = useColorMode()

// load logged in user
const userStore = useUserStore()
await userStore.fetchUser()

// Store mouse position
const mouseX = ref(0);
const mouseY = ref(0);

// Function to handle mouse click and store position
const handleMouseClick = (event: MouseEvent) => {
  mouseX.value = event.clientX;
  mouseY.value = event.clientY;

  // Update CSS variables with mouse position
  document.documentElement.style.setProperty('--mouse-x', `${mouseX.value}px`);
  document.documentElement.style.setProperty('--mouse-y', `${mouseY.value}px`);
};

// Add event listener for capturing mouse clicks
onMounted(async () => {
  await nextTick();
  colorMode.preference = "light";
  document.addEventListener('click', handleMouseClick);
});

// Clean up event listener when component is unmounted
onUnmounted(() => {
  document.removeEventListener('click', handleMouseClick);
});

</script>